import React from 'react'
import Cmnt1 from '../../assets/images/blog_d01.png'
import Blog2 from '../../assets/images/blog_d02.png'
import Blog3 from '../../assets/images/blog_d03.png'

function Comment({ comments }) {
    if (!comments || comments.length === 0) return null;

    // Sort comments by created_at
    const sorted = [...comments].sort((a, b) => new Date(a.created_at) - new Date(b.created_at));

    const safeComments = (sorted || []).filter(c => c && typeof c.reply_to !== 'undefined');
    const topLevel = safeComments.filter(c => !c.reply_to);
    const replies = safeComments.filter(c => c.reply_to);
    

    // Helper to get replies for a comment
    const getReplies = (commentId) => replies.filter(r => r.reply_to === commentId);

    // Format date nicely
    const formatDate = iso => new Date(iso).toLocaleDateString('en-US', {
        year: 'numeric', month: 'short', day: 'numeric'
    });

    return (
        <>
            <section className="row_am comment_section pb-0" data-aos="fade-up" data-aos-duration={1500} >
                <div className="container container-sm">
                    <div className="section_title">
                        <h2>{comments.length} Comentari{comments.length !== 1 ? 'i' : 'u'}</h2>
                    </div>
                <ul>
                    {topLevel.map(comment => (
                        <React.Fragment key={comment.id}>
                            <li>
                                
                                <div className="authore_info">
                                   {/* <div className="avtar">
                                        <img src={Cmnt1} alt="avatar" />
                                    </div>*/}
                                    <div className="text">
                                        <span>{formatDate(comment.created_at)}</span>
                                        <h4>{comment.author_name || 'Anonymous'}</h4>
                                    </div>
                                </div>
                                <div className="comment">
                                    <p>{comment.text}</p>
                                </div>
                            </li>

                            {getReplies(comment.id).map(reply => (
                                <li className="replay_comment" key={reply.id}>
                                    <div className="authore_info">
                                        <div className="avtar">
                                            <img src={Cmnt1} alt="avatar" />
                                        </div>
                                        <div className="text">
                                            <span>{formatDate(reply.created_at)}</span>
                                            <h4>{reply.author_name || 'Anonymous'}</h4>
                                        </div>
                                    </div>
                                    <div className="comment">
                                        <p>{reply.text}</p>
                                    </div>
                                </li>
                            ))}
                        </React.Fragment>
                    ))}
                </ul>
                </div>
            </section>
        </>
    )
}

export default Comment